/* 借入相談受付完了 本文 */
import React, { memo } from 'react';
import HeadingM from '../../molecules/HeadingM';
import ApplicationInformation from '../../molecules/ApplicationInformation';
import FooterPreExaminationApplicationInputComplete from '../../organisms/FooterPreExaminationApplicationInputComplete';

interface Props {
  ja_name: string;
  reception_cd: string;
  is_staff: boolean;
  opened_mypage: boolean;
}

const Finish: React.FC<Props> = ({ ja_name, reception_cd, is_staff, opened_mypage }) => {
  return (
    <>
      <HeadingM label="借入相談受付完了"></HeadingM>
      <div className="p-lead">
        お客様のお申込みを受け付けました。
        <br />
        ご登録のメールアドレスに借入相談受付メールを送信しました。
        <br />
        メールが届かない場合にはお申込みJAにお問合せ下さい。連絡先の電話番号はJAバンクホームページからご確認下さい。
        <br />
        お問合せの際には申込番号が必要です。
      </div>
      <ApplicationInformation ja_name={ja_name} reception_cd={reception_cd} />
      <FooterPreExaminationApplicationInputComplete
        is_staff={is_staff}
        opened_mypage={opened_mypage}
      />
    </>
  );
};

export default memo(Finish);
